import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  authenticateWithBiometrics,
  canUseNativeBiometrics,
  isBiometricSessionUnlocked,
  isBiometricUnlockEnabled,
} from '../lib/nativeBiometrics';

export default function BiometricUnlockGate() {
  const { user, isBootstrapping } = useAuth();
  const navigate = useNavigate();
  const [needsUnlock, setNeedsUnlock] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isBootstrapping) {
      return;
    }

    const shouldLock =
      Boolean(user) &&
      canUseNativeBiometrics() &&
      isBiometricUnlockEnabled() &&
      !isBiometricSessionUnlocked();

    setNeedsUnlock(shouldLock);
  }, [isBootstrapping, user]);

  const handleUnlock = async () => {
    setBusy(true);
    setError('');
    const result = await authenticateWithBiometrics();
    setBusy(false);

    if (!result.ok) {
      setError(result.reason || 'Unable to unlock with biometrics');
      return;
    }

    setNeedsUnlock(false);
  };

  if (!needsUnlock) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.72)',
        backdropFilter: 'blur(8px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 380,
          borderRadius: 20,
          background: '#ffffff',
          padding: 24,
          boxShadow: '0 24px 80px rgba(15,23,42,0.28)',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: 28, fontWeight: 700, color: '#0f172a', marginBottom: 10 }}>
          Unlock Qureo
        </div>
        <p style={{ fontSize: 14, lineHeight: 1.5, color: '#475569', marginBottom: 18 }}>
          Use biometrics or your device credential to continue in the native app.
        </p>
        {error ? (
          <div style={{ marginBottom: 12, color: '#b91c1c', fontSize: 13 }}>{error}</div>
        ) : null}
        <button
          type="button"
          onClick={handleUnlock}
          disabled={busy}
          style={{
            width: '100%',
            border: 'none',
            borderRadius: 12,
            padding: '13px 16px',
            background: 'var(--primary)',
            color: '#fff',
            fontSize: 15,
            fontWeight: 700,
            cursor: busy ? 'wait' : 'pointer',
          }}
        >
          {busy ? 'Authenticating...' : 'Unlock with Biometrics'}
        </button>
        <button
          type="button"
          onClick={() => navigate('/signin', { replace: true })}
          style={{
            width: '100%',
            border: '1px solid #e2e8f0',
            borderRadius: 12,
            padding: '13px 16px',
            background: '#fff',
            color: '#0f172a',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            marginTop: 10,
          }}
        >
          Use sign in instead
        </button>
      </div>
    </div>
  );
}
